export default __webpack_public_path__ + "static/media/sectorBreakdown.30a77793.png";